import axios from "axios";
import ErrorInterceptor from "./interceptors/error.interceptor";
import HttpRequestInterceptor from "./interceptors/http.request.interceptor";
import { Constant } from "../../helper/constant";

const http = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/`,
  timeout: Constant.apiTimeout
});

const navigatorAPI = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_API}/api/`,
  timeout: Constant.apiTimeout
});

HttpRequestInterceptor(http);
ErrorInterceptor(http);

HttpRequestInterceptor(navigatorAPI);
ErrorInterceptor(navigatorAPI);

export default http;
export { navigatorAPI };
